<template>
  <div>
    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @sort-changed="change_sort"
      bordered
      head-variant="light"
      no-local-sorting
      striped
      responsive
    >
      <template slot="cell(form_template_name)" slot-scope="{ index, item }">
        <router-link :to="{ name: 'form_entry.edit', params: { id: item.id } }">
          <default-display
            :value="item.form_template_name"
            default-value="-"
          ></default-display>
        </router-link>
      </template>
      <template slot="cell(other_name)" slot-scope="{ index, item }">
        <router-link :to="{ name: 'form_entry.edit', params: { id: item.id } }">
          <default-display
            :value="item.other_name"
            default-value="-"
          ></default-display>
        </router-link>
      </template>
      <template slot="cell(other_id)" slot-scope="{ index, item }">
        <number-display :decimals="0" :value="item.other_id" />
      </template>
      <template slot="cell(uuid)" slot-scope="{ index, item }">
        <default-display :value="item.uuid"></default-display>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.created_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(created_user)" slot-scope="{ index, item }">
        <lookup-display
          :list="optionUserItemsById"
          :value="item.created_user"
          default-value="-"
          display-field="username"
        ></lookup-display>
      </template>
      <template slot="cell(submitted_user)" slot-scope="{ index, item }">
        <lookup-display
          :list="optionUserItemsById"
          :value="item.submitted_user"
          default-value="-"
          display-field="username"
        ></lookup-display>
      </template>
      <template slot="cell(sign_off_done)" slot-scope="{ index, item }">
        <boolean-display :value="item.sign_off_done"></boolean-display>
      </template>
      <template slot="cell(tags)" slot-scope="{ index, item }">
        <b-badge
          :key="tag_index"
          v-for="(tag, tag_index) in items[index].tags"
          variant="primary"
          >{{ tag }}</b-badge
        >
      </template>

      <template slot="cell(actions)" slot-scope="{ index, item }">
        <b-button variant="primary" @click="downloadPDF(item)"
          >Download</b-button
        >
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'form_entry.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils.js";
import schema from "../../../app/schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar.vue";
import OListPaging from "../../../vue-ocom/components/list/OListPaging.vue";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay.vue";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay.vue";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay.vue";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay.vue";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay.vue";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad.vue";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";
import { fileDownload } from "../../../vue-ocom/filesystem/fileDownload.js";
import axios from "axios";
import _ from "lodash";

export default {
  components: {
    EmoticonSadIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("FormEntry", "form_entry"),
    CreateGroupPermissionMixin("FormEntry"),
    CreateCodeTableFetchMixin(["User", "FormTemplateVersion"]),
  ],
  props: {
    category: { type: String, default: null },
    otherId: { type: Number, default: null },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.FormEntry,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.FormEntry),

      filter_list: [
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
    };
  },
  methods: {
    before_get_all(list_options) {
      var result = _.cloneDeep(list_options);

      var query = {
        and: [
          ["other_id", "eq", this.otherId],
          ["other_name", "eq", this.category],
        ],
      };

      result.filter = "all";

      if (result.query) {
        result.query = { and: [result.query, query] };
      } else {
        result.query = query;
      }

      return result;
    },
    downloadPDF(item) {
      var url = `${process.env.VUE_APP_ROOT_API}/forms247/entry/pdf/${item.id}/`;
      var filename = "form_entry.pdf";
      var form_template_version = item.form_template_version;

      if (form_template_version) {
        var form_template_version_item =
          this.optionFormTemplateVersionItemsById[form_template_version];

        if (
          form_template_version_item &&
          form_template_version_item.form_template_name
        ) {
          filename =
            form_template_version_item.form_template_name + "-" + item.id;
        }
      }

      axios
        .get(url, { responseType: "blob" })
        .then(function (response) {
          if (response.data) {
            fileDownload(
              response.data,
              filename,
              response.headers["content-type"]
            );
          }
        })
        .catch(function (error) {});
    },
  },
  computed: {
    item_tags() {
      return this.item.tags || [];
    },
    fields() {
      return [
        { key: "form_template_name", label: "Form Name", sortable: false },
        fieldToTableColumn(this.schema, "created_date"),
        fieldToTableColumn(this.schema, "created_user"),
        fieldToTableColumn(this.schema, "submitted_user"),
        fieldToTableColumn(this.schema, "sign_off_done"),
        fieldToTableColumn(this.schema, "tags"),
        { key: "actions", label: "", sortable: false },
      ];
    },
  },
};
</script>
